import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/auth/auth.service';

@Component({
  selector: 'app-refresh-token',
  templateUrl: './refresh-token.component.html',
  styleUrls: ['./refresh-token.component.scss']
})
export class RefreshTokenComponent implements OnInit {

  constructor(private auth: AuthService) { }

  //提供給子系統靜默刷新token用，子系統會通過iframe執行
  ngOnInit(): void {
    console.log('Initializing token refresh component');
    this.auth.refreshToken();
  }
}
